import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const LanguageRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname !== "/") return;

    const saved = localStorage.getItem("preferred_locale");
    if (saved) return; // user already chose manually

    const browserLang = (navigator.language || "").toLowerCase();
    if (browserLang.startsWith("fr")) {
      navigate("/fr", { replace: true });
    } else if (browserLang.startsWith("en")) {
      navigate("/en", { replace: true });
    }
  }, [location.pathname, navigate]);

  return null;
};

export default LanguageRedirect;
